var React = require('react');

module.exports = React.createClass({
  render: function() {
    var baseProps = {
      'width': '16px',
'height': '16px',
'viewBox': '0 0 16 16',
'version': '1.1',
'xmlns': 'http://www.w3.org/2000/svg',
'xmlnsXlink': 'http://www.w3.org/1999/xlink',
      className: 'svg-icon',
      dangerouslySetInnerHTML: {
        __html: " <!-- Generator: Sketch 45.1 (43504) - http://www.bohemiancoding.com/sketch --> <title>icons/info-icon</title> <desc>Created with Sketch.</desc> <defs></defs> <g id=\"COLLEGE-ADMIN\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <g id=\"B-0.1-Onboarding---College---Admin\" transform=\"translate(-428.000000, -912.000000)\" fill=\"#757575\"> <g id=\"Body-Segment\" transform=\"translate(60.000000, 257.000000)\"> <g id=\"wrong-info\" transform=\"translate(368.000000, 654.000000)\"> <g id=\"icons/info-icon\" transform=\"translate(0.000000, 1.000000)\"> <g id=\"info-icon\"> <path d=\"M8,0 C3.58551232,0 0,3.58551232 0,8 C0,12.4144877 3.58551232,16 8,16 C12.4144877,16 16,12.4144877 16,8 C16,3.58551232 12.4144877,0 8,0 Z M8,0.64 C12.0686061,0.64 15.36,3.93139392 15.36,8 C15.36,12.0686061 12.0686061,15.36 8,15.36 C3.93139392,15.36 0.64,12.0686061 0.64,8 C0.64,3.93139392 3.93139392,0.64 8,0.64 Z M7.61,4.13 C7.5412,4.13 7.5,4.1712 7.5,4.24 L7.5,5.08 C7.5,5.1488 7.54088,5.2 7.61,5.2 L8.39,5.2 C8.45848,5.2 8.5,5.1488 8.5,5.08 L8.5,4.24 C8.5,4.1712 8.4588,4.13 8.39,4.13 L7.61,4.13 Z M7.59,6.44 C7.54815008,6.45618496 7.52,6.4984 7.52,6.55 L7.52,11.82 C7.52,11.8888 7.5612,11.93 7.63,11.93 L8.37,11.93 C8.4388,11.93 8.48,11.88912 8.48,11.82 L8.48,6.55 C8.48,6.4812 8.43912,6.44 8.37,6.44 L7.63,6.44 C7.61288,6.44 7.60395008,6.43460512 7.59,6.44 Z\" id=\"Shape\" fill-rule=\"nonzero\"></path> </g> </g> </g> </g> </g> </g> ",
      }
    };
    var props = Object.assign({}, baseProps, this.props);
    return React.createElement('svg', props);
  },
});



// WEBPACK FOOTER //
// ./node_modules/dk-ui-lib/assets/info-icon.svg